import React from "react";
import { Header } from "../../pages/Home";
import styles from "./DangerCard.module.css";
import { BsExclamationOctagon } from "react-icons/bs";
import CustomButton from "../CustomButton";

// entities = project / organization
function DangerCard({ onClick, className, buttonTitle="Delete", bulletPoint2 }) {

  return (
    <div className={`rounded-4 overflow-hidden ${styles.container} ${className}`}>
      <Header
        title="Danger"
        className={styles.header}
        icon={<BsExclamationOctagon size={30} />}
        showButton={false}
      />

      <div className="p-4">
        <ul className={styles.content}>
          <li className="p4">This action <strong>cannot be undone.</strong> </li>
          <li className="p4">
            {bulletPoint2}
          </li>
          <li className="list-unstyled mt-3">
            <CustomButton variant="danger" onClick={onClick}>
              {buttonTitle}
            </CustomButton>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default DangerCard;


// example
// <DangerCard
//   onClick={() => setShowDeleteModel(true)}
//   bulletPoint2={<div>Deleting this <strong>Organization will permanently remove</strong> all associated data, including projects, workstreams, papers, and supplementary materials.</div>}
//   buttonTitle="Delete Organization"
// />